module.exports = __webpack_public_path__ + "static/img/3.10347c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/3.png
// module id = 481
// module chunks = 1